module.exports = __webpack_public_path__ + "icon2.svg?24c2f09f56f34e1e6185f91aa9a53183";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_svg/icon2.svg
// module id = 81
// module chunks = 0